import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/tiktok-scheduler")({
	beforeLoad: () => {
		throw redirect({ to: "/channels/tiktok" });
	},
});
